import React from "react";
import RateConvertModalContent from "@/components/modal/rate-convert-modals/components/rate-convert-modal-content";

type LikeConvertModalProps = {
  convertId: string;
};

const LikeConvertModal = ({ convertId }: LikeConvertModalProps) => {
  const ratePresets = [
    "Matches target voice perfectly",
    "Improved emotional expression",
    "High quality output",
    "Other",
  ];
  return (
    <RateConvertModalContent
      ratePresets={ratePresets}
      type={"like"}
      convertId={convertId}
    />
  );
};

export default LikeConvertModal;
